var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconmaterialDirectionsBike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.27,
    height: 18.168,
    viewBox: "0 0 21.27 18.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-directions-bike",
    "data-name": "Icon material-directions-bike",
    d: "M13.737,5.795a1.772,1.772,0,1,0-1.772-1.772A1.778,1.778,0,0,0,13.737,5.795Zm-9.305,5.76a4.431,4.431,0,0,0,0,8.862,4.431,4.431,0,0,0,0-8.862Zm0,7.533a3.1,3.1,0,0,1,0-6.2,3.1,3.1,0,0,1,0,6.2Zm5.14-8.862L11.7,8.1l.709.709a6.209,6.209,0,0,0,4.52,1.861V8.9a4.4,4.4,0,0,1-3.19-1.329L12.053,5.884a2.173,2.173,0,0,0-1.418-.532,1.487,1.487,0,0,0-1.241.532L6.913,8.365a1.75,1.75,0,0,0-.532,1.241,1.487,1.487,0,0,0,.532,1.241l2.836,2.481v4.431h1.772V12.264l-1.95-2.038Zm7.267,1.329a4.431,4.431,0,1,0,4.431,4.431A4.388,4.388,0,0,0,16.838,11.555Zm0,7.533a3.1,3.1,0,1,1,3.1-3.1A3.14,3.14,0,0,1,16.838,19.088Z",
    transform: "translate(0 -2.25)",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmaterialDirectionsBike);
export default __webpack_public_path__ + "static/media/Icon material-directions-bike.faf8e68b5565db9e4bef90e3a9d60bb5.svg";
export { ForwardRef as ReactComponent };